import type { ReactNode } from 'react';
import { ISOMETRIC_COS, ISOMETRIC_SIN, iso } from './isometric';

export function IsoFace({
  x,
  y,
  z,
  children,
}: {
  x: number;
  y: number;
  z: number;
  children: ReactNode;
}) {
  const p = iso(x, y, z);
  return (
    <g
      transform={`matrix(${ISOMETRIC_COS} ${ISOMETRIC_SIN} ${-ISOMETRIC_COS} ${ISOMETRIC_SIN} ${p.x} ${p.y})`}
    >
      {children}
    </g>
  );
}
